
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.006 13.65h4.327c.321 0 .547-.197.547-.519 0-.307-.219-.505-.54-.505H7.802L9.462 4.9h1.532c.321 0 .547-.198.547-.52 0-.307-.219-.506-.54-.506H6.667c-.321 0-.547.199-.547.506 0 .322.233.52.554.52h1.524l-1.66 7.725H4.998c-.321 0-.54.198-.54.505 0 .322.226.52.547.52z","fill":"#000C1F"}})])
          )
        }
      }
    